import { z } from 'zod';

import { fieldTextSchema, requiredEmailFieldSchema, requiredFieldSchema } from 'schemas/forms/common';

import { PASSWORD_CHECK, PASSWORD_MIN_LENGTH } from 'services/util/auxiliaryUtils';

/** The username, and the password once the API says the user signs in with one (not through SSO). */
export const loginFormSchema = (asksPassword: boolean) =>
    z.object({
        username: requiredFieldSchema,
        password: asksPassword ? requiredFieldSchema : fieldTextSchema,
    });

export const resetPasswordFormSchema = z.object({ email: requiredEmailFieldSchema });

/** The password a user sets on their first sign-in, with the rules the dialog lists, and its confirmation. */
export const redefinePasswordFormSchema = z
    .object({
        newPassword: z
            .string()
            .min(1, 'yup.message.required')
            .min(PASSWORD_MIN_LENGTH, 'yup.message.string.minCharacters')
            .regex(PASSWORD_CHECK.PASSWORD_HAS_LOWERCASE_REGEXP, 'yup.message.password.required.lowerCase')
            .regex(PASSWORD_CHECK.PASSWORD_HAS_UPPERCASE_REGEXP, 'yup.message.password.required.upperCase')
            .regex(PASSWORD_CHECK.PASSWORD_HAS_DIGIT_REGEXP, 'yup.message.password.required.number')
            .regex(PASSWORD_CHECK.PASSWORD_HAS_SPECIAL_CHARACTER, 'yup.message.password.required.specialCharacter'),
        confirmPassword: z.string().min(1, 'yup.message.required'),
    })
    .superRefine(({ newPassword, confirmPassword }, ctx) => {
        if (confirmPassword !== '' && confirmPassword !== newPassword) {
            ctx.addIssue({ code: 'custom', path: ['confirmPassword'], message: 'yup.message.oneOf.matchPasswords' });
        }
    });
